export const BUILD_VERSION = '1783704247';
